const initialState = {
  fetching: false,
  fetched: false,
  //deleting: false,
  //deleted: false,
  //saving: false,
  //saved: false,
  items: null,
  error: null,
  nbResult: 0,
  paginationPage: 1,
  paginationTotalPages: 1
  //countArticlesByAuthor: 0,
  //countArticlesFetching: false,
  //countArticlesFetched: false
};
export const articlesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_ARTICLES_LIST": {
      return initialState;
    }
    /*case "UPDATE_ARTICLE_STATUS_FULFILLED": {
      const { data } = action.payload.data;
      return {
        ...state,
        items: state.items.map(
          article =>
            parseInt(article.id, 10) === parseInt(data.id, 10)
              ? { ...article, status: data.status }
              : article
        )
      };
    }
    case "SET_PAGINATION_PAGE": {
      return { ...state, paginationPage: action.pageNumber };
    }
    case "SET_PAGINATION_TOTAL_PAGE": {
      return { ...state, paginationTotalPages: action.totalPages };
    }*/
    case "RESET_RESOURCES": {
      return { ...initialState };
    }
    case "FETCH_ARTICLES_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "SET_FETCHING": {
      return { ...state, fetching: action.payload };
    }

    /*case "FETCH_ARTICLES_FULFILLED": {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult: nbResult
      };
    }*/
    // case "FETCH_ARTICLES_FULFILLED": {
    //   const { data, nbResult, order } = action.payload.data;

    //   const index = order;
    //   let help = { ...state.items };
    //   if (!help[index]) {
    //     help[index] = [];
    //   }
    //   // Ovoid duplicates
    //   const newItems = (data || []).filter(newItem => {
    //     return !help[index].find(item => item.id === newItem.id);
    //   });
    //   help[index] = [...help[index].concat(newItems)];

    //   return {
    //     ...state,
    //     fetching: false,
    //     fetched: true,
    //     error: null,
    //     items: { ...help },
    //     nbResult: nbResult
    //   };
    // }
    case "FETCH_ARTICLES_FULFILLED": {
      const { data, nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: [...data],
        nbResult: nbResult
      };
    }
    case "FETCH_ARTICLES_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/article.js